import {
  createStyles,
  Title,
  Text,
  Space,
  Anchor,
  Image,
  Box,
  Divider,
  List,
  Paper,
  Blockquote,
} from '@mantine/core';
import { themeColors } from '../../config/themeSettings';

const SocialImpactMeeting = () => {
  const { classes } = useStyles();

  return (
    <div>
      <div className={classes.dateCategory}>
        December 21, 2025 | India News
      </div>
      <section className={classes.header}>
        <Title order={1} className={classes.title}>
          Meeting Highlights Social Impact of "Say Help" Personal Safety Application
        </Title>
      </section>
      <div className={classes.container}>
        <Box className={classes.sectionCenter}>
          <Paper className={classes.meetingOutline} shadow="sm" p="xl" radius="md">
            <Title order={3} className={classes.meetingTitle}>
              Meeting Outline: New Year GIFT to North-East Women in Delhi
            </Title>
            <Space h="md" />
            <Text className={classes.meetingSubtitle}>
              Safety Application Launch by USA NRI Mahesh Salgaonkar in collaboration with Helping Hands NGO under CSR initiative
            </Text>
            <Space h="md" />
            <Text size="sm" color="dimmed">
              Date: December 20, 2025 | Time: 5:00 - 7:00 PM (IST)
            </Text>
            <Space h="lg" />
            <Title order={5} className={classes.agendaTitle}>
              Meeting Agenda:
            </Title>
            <Space h="sm" />
            <List spacing="sm" className={classes.agendaList}>
              <List.Item>
                <strong>Introduction</strong> by Robin Hibu, IPS, President of Helping Hands NGO - Presenting the New Year Gift for women's safety
              </List.Item>
              <List.Item>
                <strong>Presentation</strong> by CEO Mahesh Salgaonkar - Overview of Say Help App: origin, benefits, download process, and operational modalities
              </List.Item>
              <List.Item>
                <strong>Q&A Session</strong> - Doubt clearance with participants
              </List.Item>
              <List.Item>
                <strong>Legal Insights</strong> by Jyoti Junggluju, Supreme Court Lawyer and Legal Advisor at Helping Hands
              </List.Item>
              <List.Item>
                <strong>Legal Perspective</strong> by Liyi Noshi, Advocate at High Court and Legal Advisor at Helping Hands
              </List.Item>
              <List.Item>
                <strong>Vote of Thanks</strong> by Dr. Sangeeta Chanu, Vice President of Helping Hands
              </List.Item>
            </List>
            <Space h="md" />
            <Text size="lg">
              The application features voice activation with location tracking, video recording, and audio recording facilities serving as evidence for personal safety.
            </Text>
          </Paper>

          <Space h="xl" />
          <Divider />
          <Space h="xl" />

          <Paper className={classes.highlightSection} shadow="sm" p="xl" radius="md">
            <Title order={3} className={classes.highlightTitle}>
              Key Meeting Highlights
            </Title>
            <Space h="lg" />
            <Image
              src={require('../../assets/news/meeting-sayhelp-india.jpg')}
              alt="Say Help Delhi Meeting with Robin Hibu and Asha Devi"
              fit="contain"
              radius="md"
            />
            <Space h="md" />
            <Title order={4} className={classes.resumeSubtitle}>
              Say Help Personal Safety App Discussed at Delhi Meeting: Robin Hibu Highlights Women's Safety
            </Title>
            <Space h="md" />
            <Text className={classes.resumeText}>
              A meeting was held under the chairmanship of Mr. Robin Hibu, IPS, President of Helping Hands NGO, bringing together Mr. Mahesh Salgaonkar (Founder of Say Help App), senior police officials, advocates, medical professionals, social workers, and Smt. Asha Devi, mother of Nirbhaya.
            </Text>
            <Space h="md" />
            <Blockquote color="orange" cite="– Smt. Asha Devi, mother of Nirbhaya">
              Had such an application existed earlier, my daughter would have been alive today.
            </Blockquote>
          </Paper>

          <Space h="xl" />
          <Divider />
          <Space h="xl" />

          <section className={classes.paragraph}>
            <Space h="md" />
            <Text>
              <strong>December 21, 2025</strong>
            </Text>
            <Space h="md" />
            <Text>
              A meeting was convened under the chairmanship of Mr. Robin Hibu, President of Helping Hands NGO (Pan–North East NGO), to deliberate on the features, implementation, and social relevance of the "Say Help" personal safety application. The discussion focused on how technology can strengthen personal security, particularly for women and vulnerable groups.
            </Text>
            <Space h="md" />
            <Text>
              The meeting was attended by the Founder of the Say Help App, Mr. Mahesh Salgaonkar, senior police officials including Smt. Kiran Sethi, Police Incharge of GB Road, Delhi, advocates, medical professionals, social workers, students, and Smt. Asha Devi, the mother of Nirbhaya. During the interaction, Smt. Asha Devi made an emotional remark, stating that had such an application existed earlier, her daughter might have been alive today.
            </Text>
            <Space h="md" />
            <Text>
              Several prominent personalities from across the country participated in the meeting, including the Chairman of the Arunachal Pradesh Human Rights Commission, noted Delhi educationist and women activist Mrs. Kiran Kapoor, former AIIMS counsellor Dr. Suman Bhardwaj, women activists Yogita and Dr. Sangeeta Chanu, Chairman of PARI NGO, senior officials and social workers from the North-East, legal professionals, journalists, and a large number of students and women. Media representatives from the North-East, based in Delhi, also attended the event.
            </Text>
            <Space h="md" />
            <Title order={4} className={classes.titleLeft}>
              Say Help App Features
            </Title>
            <Space h="md" />
            <Text>
              The Say Help App was presented as an advanced personal safety and emergency response application designed to provide immediate assistance during situations such as medical emergencies, assault, robbery, kidnapping, or any imminent threat. The application is voice-activated and also features a panic button, enabling users to trigger distress alerts instantly.
            </Text>
            <Space h="md" />
            <Text>
              Once activated, either through a single tap or through up to five pre-configured voice commands, the application discreetly switches on the mobile phone's camera and microphone, captures real-time GPS coordinates, and transmits continuous live audio, video, and location data to pre-designated emergency contacts and concerned law enforcement authorities. The live feed continues until the alert is manually closed. All audio and video data generated during the activation period is securely stored and, upon closure of the alert, can serve as electronic evidence under Section 94 of the Bharatiya Nagarik Suraksha Sanhita (BNSS), 2023, subject to due legal procedures.
            </Text>
            <Space h="md" />
            <Text>
              The developers emphasized that the application is designed to function effectively even under minimal network availability, including low mobile data strength or Wi-Fi connectivity. The Say Help App is available on both Android and iOS platforms.
            </Text>
            <Space h="md" />
            <Image
              src="https://apdirect.in/wp-content/uploads/2025/12/img_4715.jpg"
              alt="Say Help Social Impact Meeting"
              fit="contain"
            />
            <div className={classes.imageAttribution}>
              Image from AP Direct
            </div>
            <Space h="lg" />
            <Title order={4} className={classes.titleLeft}>
              Delhi Implementation
            </Title>
            <Space h="md" />
            <Text>
              In Delhi, the Municipal Corporation of Delhi (MCD) has agreed to allow public advertisement of the Say Help App. Additionally, the Delhi Police has initiated a pilot project of the application in the Central District, with other related departments expressing their willingness to support and adopt the platform.
            </Text>
            <Space h="md" />
            <Text>
              Mr. Robin Hibu, on behalf of Helping Hands NGO, reiterated that the organization has consistently worked for the safety and welfare of women from the North-East region. He emphasized that the Say Help App would significantly strengthen crime prevention mechanisms by enabling law enforcement agencies to establish a strong evidentiary chain, thereby ensuring swift action against offenders and enhancing overall public safety.
            </Text>
            <Space h="md" />
          </section>
          <Divider></Divider>
          <Text className={classes.footNote}>
            Story by{' '}
            <Anchor
              href="https://apdirect.in/meeting-highlights-social-impact-of-say-help-personal-safety-application/"
              target="_blank">
              Marter Bagra
            </Anchor>
            . Source:{' '}
            <Anchor
              href="https://apdirect.in/meeting-highlights-social-impact-of-say-help-personal-safety-application/"
              target="_blank">
              AP Direct
            </Anchor>
          </Text>
        </Box>
      </div>
    </div>
  );
};

export default SocialImpactMeeting;

const useStyles = createStyles(theme => ({
  root: {
    fontFamily: 'Poppins',
    backgroundColor: themeColors.white,
    height: '100%',
    width: '100%',
    overflowX: 'hidden',
  },

  dateCategory: {
    fontSize: 14,
    fontWeight: 'normal',
    marginBottom: 10,
    textAlign: 'center',
    color: '#757575',
  },

  container: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 20,
  },

  header: {
    textAlign: 'center',
    display: 'grid',
    gridTemplateColumns: 'minmax(min-content, 900px)',
    gridTemplateRows: 'auto',
    justifyContent: 'center',
    justifyItems: 'center',
    gap: 20,
  },

  footNote: {
    fontSize: 12,
    marginTop: 20,
    color: '#757575',
  },

  imageAttribution: {
    fontSize: 12,
    marginTop: 10,
    color: '#757575',
    textAlign: 'center',
  },

  title: {
    fontFamily: 'Poppins',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: themeColors.anchor,
  },

  titleLeft: {
    fontFamily: 'Poppins',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: themeColors.anchor,
  },

  paragraph: {
    fontFamily: 'Poppins',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: themeColors.anchor,
  },

  sectionCenter: {
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '90vw',
    maxWidth: 900,
  },

  meetingOutline: {
    backgroundColor: '#fff',
    border: '2px solid #e9ecef',
  },

  meetingTitle: {
    fontFamily: 'Poppins',
    fontWeight: 'bold',
    color: themeColors.anchor,
    marginBottom: 0,
    textAlign: 'center',
  },

  meetingSubtitle: {
    fontFamily: 'Poppins',
    fontSize: 16,
    color: '#495057',
    fontWeight: 500,
  },

  agendaTitle: {
    fontFamily: 'Poppins',
    fontWeight: 600,
    color: themeColors.anchor,
    marginTop: 10,
  },

  agendaList: {
    fontFamily: 'Poppins',
    fontSize: 15,
    lineHeight: 1.6,
    color: '#495057',
  },

  highlightSection: {
    backgroundColor: '#fff',
    border: '2px solid #e9ecef',
  },

  highlightTitle: {
    fontFamily: 'Poppins',
    fontWeight: 'bold',
    color: themeColors.anchor,
    textAlign: 'center',
    marginBottom: 0,
  },

  resumeSubtitle: {
    fontFamily: 'Poppins',
    fontWeight: 600,
    color: themeColors.anchor,
    textAlign: 'center',
  },

  resumeText: {
    fontFamily: 'Poppins',
    fontSize: 15,
    lineHeight: 1.7,
    color: '#495057',
  },
}));
